import React from "react";
import "./style.css";
import { getInitials } from "../../../../../../helper";
import moment from "moment";

const getActionText = (log) => {
  const userName = log?.user?.name || "Unknown";
  const action = log.action;
  const target = log.target;

  let actionText = "";

  if (action === "add") {
    actionText = `${userName} added new ${target}`;
  } else if (action === "update") {
    actionText = `${userName} updated ${target}`;
  } else if (action === "delete") {
    actionText = `${userName} deleted ${target}`;
  } else {
    actionText = `${userName} updated ${target}`;
  }

  let caseNumber = "";

  if (target === "case") {
    caseNumber =
      log?.new_value?.case_number || log?.old_value?.case_number || "";
  } else if (target === "records") {
    caseNumber = log?.case?.case_number || "";
  }

  if (caseNumber) {
    const isAM = caseNumber.endsWith("-AM");
    const caseColor = isAM ? "#1677ff" : "#ff4d4f"; // blue for AM, red for PM

    return (
      <>
        {actionText} — Case Number :{" "}
        <span style={{ color: caseColor }}>{caseNumber}</span>
      </>
    );
  }

  return actionText;
};

const formatDate = (dateStr) => {
  return moment(dateStr).format("Do MMMM, YYYY");
};

const ProjectTraceability = ({ logs = [] }) => {
  return (
    <div className="d-project_traceability_container">
      {logs.map((log, index) => {
        return (
          <div className="project_traceability_body" key={index}>
            <div className="project_traceability_section">
              <div className="project_traceability_indentifier_section">
                <p>{getInitials(log?.user?.name || "U")}</p>
              </div>
              {index !== logs.length - 1 && (
                <div className="project_traceability_line" />
              )}
            </div>
            <div className="project_traceability_indentifier_details">
              <p>{getActionText(log)}</p>
              <p>{formatDate(log.created_at)}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ProjectTraceability;
